import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/MandantService";
const store = {};
const mutations = {
    SET_OPEN_MANDANT_LIST(state, posts) {
        state.openMandantList = posts;
        state.openMandantListIsLoading = false;
    },
    SET_MANDANT_LIST(state, posts) {
        state.mandantList = posts;
        state.mandantListIsLoading = false;
    },
    GET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.mandantDetail = posts.data;
            state.mandantDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.mandantDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    openMandantListIsLoading: false,
    mandantListIsLoading: false,
    openMandantList: [],
    mandantList: [],
    mandantDetail: {},
    mandantDetailChanged: false
};
const getters = {};
const actions = {
    getOpenMandantList({ commit }) {
        state.openMandantListIsLoading = true;
        axios
            .get(baseUri + '/GetOpenMandantList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_OPEN_MANDANT_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getMandantList({ commit }) {
        state.mandantListIsLoading = true;
        axios
            .get(baseUri + '/list')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_MANDANT_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getMandantDetail({ commit }, data ) {
        state.mandantListIsLoading = true;
        var formData = new FormData();
        formData.append("manId", data.manId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveMandantDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.mandantDetail));
        axios
            .post(baseUri + '/update', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('UPDATE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}